import { PropsWithChildren, FC } from 'react'
import { Col, Layout, Space } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import styles from '@OpsQuality/styles.css'

import Box from '~/core/Box'
import Link from '~/core/Link'
import Text from '~/core/Text'
import SecurePlusIcon from '~/components/SecurePlusIcon'
import { adminJobRequestQuery_jobRequest as JobRequestType } from '../__generated__/adminJobRequestQuery'
import colors from '~/styles/_colors.css'

import { SyntheticEvent } from './types'

interface TopNavPropsType {
    goBack: (event: SyntheticEvent) => void
    jobRequest?: JobRequestType | null
}

const TopNav: FC<PropsWithChildren<TopNavPropsType>> = props => {
    const { goBack, jobRequest } = props

    return (
        <Layout.Header className={styles.layoutHeader}>
            <Box className={styles.wrapper} alignItems="center">
                <Box
                    style={{
                        marginLeft: 20,
                        width: '20px',
                    }}
                >
                    <Box>
                        <Space>
                            <Link
                                name="backBtn"
                                placement="top_navigation_bar"
                                onClick={goBack}
                            >
                                <Col xs={0} md={24}>
                                    <HomeOutlined
                                        style={{
                                            display: 'flex',
                                            fontSize: '20px',
                                        }}
                                    />
                                </Col>
                            </Link>
                        </Space>
                    </Box>
                </Box>
                <Box className={styles.jobRequestNameHeader}>
                    <Text style={{ margin: '0 8px' }}>/</Text>
                    {jobRequest?.name && jobRequest?.project?.isSecurePlus && (
                        <SecurePlusIcon
                            iconColor={
                                colors.success
                                    ? colors.success
                                    : colors.shroudBlue
                            }
                            iconSize="21px"
                            marginRight="8px"
                        />
                    )}
                    {jobRequest?.name}
                    {jobRequest?.rfqNumber && (
                        <Text style={{ paddingLeft: '4px' }}>
                            - RFQ#{jobRequest?.rfqNumber}
                        </Text>
                    )}
                </Box>
            </Box>
        </Layout.Header>
    )
}

export default TopNav
